var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "other-services", title: "Other Services" } },
    [
      _c("template", { slot: "copy" }, [
        _c(
          "p",
          [
            _vm._v(
              "\n      Font Awesome use several other services to run\n      "
            ),
            _c("site-link", { attrs: { to: { name: "home" } } }, [
              _vm._v("fontawesome.com"),
            ]),
            _vm._v(", the "),
            _c("site-link", { attrs: { to: { hash: "#cdns" } } }, [
              _vm._v("content delivery networks"),
            ]),
            _vm._v(
              ", communicate\n      with users and customers, and operate its business:\n    "
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass: "roomy",
            attrs: {
              summary:
                "a list of content delivery network service providers Font Awesome uses",
            },
          },
          [
            _c("thead", [
              _c("tr", [
                _c("th", [_vm._v("Service")]),
                _vm._v(" "),
                _c("th", [_vm._v("Privacy Notice")]),
                _vm._v(" "),
                _c("th", [_vm._v("Description")]),
              ]),
            ]),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://aws.amazon.com",
                      },
                    },
                    [
                      _vm._v(
                        "\n              Amazon Web Services\n            "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://aws.amazon.com/privacy",
                      },
                    },
                    [
                      _vm._v(
                        "\n              https://aws.amazon.com/privacy\n            "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "Provides cloud servers and services for running websites."
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://basecamp.com/",
                      },
                    },
                    [_vm._v("\n              Basecamp\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://basecamp.com/about/policies/privacy",
                      },
                    },
                    [
                      _vm._v(
                        "\n              https://basecamp.com/about/policies/privacy\n            "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v("Manages Font Awesome team projects.")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://www.backerkit.com",
                      },
                    },
                    [_vm._v("\n              Backerkit\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://www.backerkit.com/privacy_policy",
                      },
                    },
                    [
                      _vm._v(
                        "\n              https://www.backerkit.com/privacy_policy\n            "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "Manages Kickstarter campaign rewards delivery and shipping logistics."
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _c(
                    "a",
                    { attrs: { target: "_blank", href: "https://github.com" } },
                    [_vm._v("\n              GitHub\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://help.github.com/privacy-policy",
                      },
                    },
                    [
                      _vm._v(
                        "\n              https://help.github.com/privacy-policy\n            "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "Hosts source code and a private repository for Pro customers."
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://analytics.google.com",
                      },
                    },
                    [_vm._v("\n              Google Analytics\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://www.google.com/analytics/terms",
                      },
                    },
                    [
                      _vm._v(
                        "\n              https://www.google.com/analytics/terms\n            "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _vm._v(
                      "\n            Compiles visitor statistics on\n            "
                    ),
                    _c("site-link", { attrs: { to: { name: "home" } } }, [
                      _vm._v("fontawesome.com"),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://www.helpscout.net",
                      },
                    },
                    [_vm._v("\n              HelpScout\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "httpsword-wrap ://www.helpscout.net/company/legal/terms-of-service",
                      },
                    },
                    [
                      _vm._v(
                        "\n              https://www.helpscout.net/company/legal/terms-of-service\n            "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v("Facilitates response to support questions."),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://www.kickstarter.com",
                      },
                    },
                    [_vm._v("\n              Kickstarter\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://www.kickstarter.com/privacy",
                      },
                    },
                    [
                      _vm._v(
                        "\n              https://www.kickstarter.com/privacy\n            "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v("Hosts crowd-funding campaigns.")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _c(
                    "a",
                    { attrs: { target: "_blank", href: "https://sentry.io" } },
                    [_vm._v("\n              Sentry\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://sentry.io/privacy",
                      },
                    },
                    [
                      _vm._v(
                        "\n              https://sentry.io/privacy\n            "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v("Tracks technical errors.")]),
              ]),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }